import {
  buttonDisable,
  getAnsersCount,
  getInteractionBarIcon,
} from "../SurveyElements";

export const setInteractionResponse = (
  id,
  data,
  moment,
  lastUpdatedDate,
  colIsIpResponseSubmitted
) => {
  let isIncrease = true;
  let interactionResponses = getInteractionResponse();
  let tabId = getInteractionTabId();
  if (interactionResponses[tabId] === undefined) {
    interactionResponses[tabId] = {};
  }
  const parsedData = JSON.parse(data);
  if (
    JSON?.stringify(parsedData) === "{}" ||
    JSON?.stringify(parsedData) === "[]"
  ) {
    isIncrease = false;
    delete interactionResponses[tabId][id];
  } else {
    interactionResponses[tabId][id] = removeBase64DataFromStoredData(data);
  }
  setTheInteractionResponse(interactionResponses);

  let interactionBar = document.querySelector(
    ".interaction-bar .interaction-changes"
  );
  isIncrease && interactionBar && (interactionBar.textContent = "Saving...");
  setTimeout(() => {
    // Update answered count
    let interactionBar_ = document.querySelector(".interaction-bar");
    let answered = interactionBar_.querySelector(".answered");
    let numberOfQuetions = interactionBar_.querySelector(".numberOfQuetions");
    answered.textContent = getAnsersCount(
      Object.keys(interactionResponses[tabId])?.length
    );

    // Update changes saved message
    if (isIncrease && interactionBar) {
      interactionBar.textContent =
        Object.keys(interactionResponses[tabId])?.length > 0
          ? lastUpdatedDate
            ? "Last Save: " +
              moment(new Date(lastUpdatedDate)).format("MMM D YYYY, h:mm a")
            : "Last Save: " + moment(new Date()).format("MMM D YYYY, h:mm a")
          : "No changes made";
    }

    // Submit button enable or disable
    let completebtn = document.querySelector(
      ".interaction-bar .interaction-complete-btn"
    );
    completebtn.classList.remove("disabled");
    if (
      buttonDisable(
        Object.keys(interactionResponses[tabId])?.length,
        document?.querySelectorAll(".INTERACTION_PARENT")?.length,
        false,
        colIsIpResponseSubmitted
      )
    ) {
      completebtn.classList.add("disabled");
    }

    // Update interaction bar icon
    let interactionSvgIcon = interactionBar_.querySelector(
      ".interaction-svg-icon"
    );
    interactionSvgIcon.innerHTML = getInteractionBarIcon(
      Number(getAnsersCount(answered.textContent)),
      Number(numberOfQuetions.textContent)
    );
    // localStorage.removeItem("InteractionResponseSubmit");
  }, 300);
};

export const removeBase64DataFromStoredData = (data) => {
  let parseData = JSON.parse(data);
  let key =
    Object?.keys(parseData)?.length > 0 ? Object.keys(parseData)[0] : "";
  if (key?.includes("file") && !key?.includes("-Comment")) {
    parseData[key][0].content = "";
    return JSON.stringify(parseData);
  }
  return data;
};

export const getInteractionResponse = () => {
  return JSON.parse(localStorage.getItem("InteractionResponse")) || {};
};
export const setTheInteractionResponse = (interactionResponses) => {
  localStorage.setItem(
    "InteractionResponse",
    JSON.stringify(interactionResponses || {})
  );
};

export const removeInteractionResponse = () => {
  localStorage.removeItem("InteractionResponse");
  localStorage.removeItem("InteractionResponseSubmit");
};

export const getInteractionSubmit = () => {
  return JSON.parse(localStorage.getItem("InteractionResponseSubmit")) || {};
};

export const getInteractionTabId = (flag) => {
  let tabId =
    document
      ?.querySelector(".report-updates-tab .active")
      ?.getAttribute("data-pk_report_update_id") || "0";
  return tabId;
};

export const getInteractionSubmitOfTab = () => {
  let tabId = getInteractionTabId();
  let intSubmit = getInteractionSubmit();
  return intSubmit[tabId] === undefined ? false : intSubmit[tabId];
};

export const setInteractionSubmit = (flag) => {
  let intSubmit = getInteractionSubmit();
  let tabId = getInteractionTabId();
  if (intSubmit[tabId] === undefined) {
    intSubmit[tabId] = {};
  }
  intSubmit[tabId] = flag;
  localStorage.setItem("InteractionResponseSubmit", JSON.stringify(intSubmit));
};

export const reloadInteractionOnSessionStart = (
  resultData,
  moment,
  sessionId
) => {
  if (resultData) {
    let colIsIpResponseSubmitted =
      resultData?.find((f) => f.colSessionToken === sessionId)
        ?.colIsIpResponseSubmitted || false;
    const lastUpdatedDate = resultData.reduce((latest, current) => {
      return new Date(current.colUpdatedAt) > new Date(latest.colUpdatedAt)
        ? current
        : latest;
    }).colUpdatedAt;
    resultData?.forEach((item) => {
      setInteractionResponse(
        item?.fkCpFolderViewId,
        item?.colResponseData,
        moment,
        lastUpdatedDate,
        colIsIpResponseSubmitted
      );
    });
  } else {
    let interactionBar = document?.querySelector(".interaction-bar");
    let aswer = interactionBar?.querySelector(".answered");
    let changes = interactionBar?.querySelector(".interaction-changes");
    if (aswer && changes) {
      aswer.textContent = getAnsersCount(0);
      let respnse = getInteractionResponse();
      let tabId = getInteractionTabId();
      delete respnse[tabId];
      setTheInteractionResponse(respnse);
      changes.textContent = "No changes made";
    }
  }
  return getInteractionResponse();
};

export const updateInteractivePanel = (moment) => {
  setTimeout(() => {
    let lastUpdatedDate = null;
    let interactionResponses = getInteractionResponse();
    let isCount =
      Object.keys(interactionResponses)?.length > 0
        ? Object.keys(interactionResponses[0])?.length
        : 0;
    let interactionBar = document.querySelector(
      ".interaction-bar .interaction-changes"
    );
    // Update answered count
    let interactionBar_ = document.querySelector(".interaction-bar");
    let answered = interactionBar_.querySelector(".answered");
    let numberOfQuetions = interactionBar_.querySelector(".numberOfQuetions");
    answered.textContent = getAnsersCount(isCount);

    // Update changes saved message
    // if (interactionBar) {
    //   interactionBar.textContent =
    //     Object.keys(interactionResponses[0])?.length > 0
    //       ? lastUpdatedDate
    //         ? "Last Save: " +
    //           moment(new Date(lastUpdatedDate)).format("MMM D YYYY, h:mm a")
    //         : "Last Save: " + moment(new Date()).format("MMM D YYYY, h:mm a")
    //       : "No changes made";
    // }

    // Submit button enable or disable
    let completebtn = document.querySelector(
      ".interaction-bar .interaction-complete-btn"
    );
    completebtn.classList.remove("disabled");
    if (
      buttonDisable(
        isCount,
        document?.querySelectorAll(".INTERACTION_PARENT")?.length,
        false,
        null
      )
    ) {
      completebtn.classList.add("disabled");
    }

    // Update interaction bar icon
    // let interactionSvgIcon = interactionBar_.querySelector(
    //   ".interaction-svg-icon"
    // );
    // interactionSvgIcon.innerHTML = getInteractionBarIcon(
    //   Number(getAnsersCount(answered.textContent)),
    //   Number(numberOfQuetions.textContent)
    // );
    // localStorage.removeItem("InteractionResponseSubmit");
  }, 300);
};
